import WithHeaderAds from "../../Layout/WithHeaderAds";
import { Row, Col, Button } from "react-bootstrap";
import CodingPractice from "../../Illustrations/undraw_Developer_activity_re_39tg.svg";
import NoAuthentication from "../../Illustrations/undraw_two_factor_authentication_namy.svg";
import Offline from "../../Illustrations/undraw_Processing_re_tbdu.svg";
import Progress from "../../Illustrations/undraw_In_progress_re_m1l6.svg";
import Styles from "./index.module.css";
import Footer from "../../Components/Footer";
import SEO from "../../Seo";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <>
      <WithHeaderAds>
        <SEO
          text={`Online JavaScript Practice Ground | Learnersbucket`}
          description={`Ace your JavaScript interviews by practicing System Design, Frontend Interview questions on learnersbucket.com, it requires no signup and works offline as well.`}
        />
        <main className={Styles.homePage}>
          <Row className="align-items-center">
            <Col xs={8}>
              <p>
                Ace your JavaScript Interview, a simple platform to practice
                JavaScript questions.
              </p>
              <p>
                <Link to={`/problems`}>
                  <Button className={Styles.btnLearnersbucket}>
                    Explore Problems
                  </Button>
                </Link>
              </p>
            </Col>
            <Col xs={4}>
              <img alt={"Coding Practice"} src={CodingPractice} />
            </Col>
          </Row>
          <Row className="align-items-center">
            <Col xs={4}>
              <img
                alt={"No authentication is required"}
                src={NoAuthentication}
              />
            </Col>
            <Col xs={8}>
              <p>
                No authentication is required, we just want you to practice and
                improve your problem solving skills.
              </p>
              <p>
                <Link to={`/problems`}>
                  <Button className={Styles.btnLearnersbucket}>
                    Explore Problems
                  </Button>
                </Link>
              </p>
            </Col>
          </Row>
          <Row className="align-items-center">
            <Col xs={8}>
              <p>
                Works offline!. As we are just running JavaScript, all we need
                is a browser, thus it works even offline.
              </p>
              <p>
                <Link to={`/problems`}>
                  <Button className={Styles.btnLearnersbucket}>
                    Explore Problems
                  </Button>
                </Link>
              </p>
            </Col>
            <Col xs={4}>
              <img alt={"Works Offline!"} src={Offline} />
            </Col>
          </Row>
          <Row className="align-items-center">
            <Col xs={4}>
              <img alt={"User's Progress"} src={Progress} />
            </Col>
            <Col xs={8}>
              <p>
                As we are not storing any user data, your progress will be
                tracked in your browser itself. As long as you don't clear data
                of your browser, you are good.
              </p>
              <p>
                <Link to={`/problems`}>
                  <Button className={Styles.btnLearnersbucket}>
                    Explore Problems
                  </Button>
                </Link>
              </p>
            </Col>
          </Row>
        </main>
      </WithHeaderAds>
      <Footer />
    </>
  );
};

export default Home;
